import { DepositMethodEnum } from '@shared-web/modules/deposit/types';
import { WithdrawMethodEnum } from '@shared-web/modules/withdraw/types';

export enum CURRENCY {
  EUR = 'EUR',
  USD = 'USD',
  GBP = 'GBP',
  AED = 'AED',
}

export enum FUNDS_DIRECTION {
  DEPOSIT = 'deposit',
  WITHDRAW = 'withdraw',
}

export enum API_BANK_NETWORK_USD {
  FEDWIRE = 'usd_fedwire',
  SWIFT = 'usd_swift',
  ACH = 'us_ach',
  CUBIX = 'usd_cubix',
}

export enum API_BANK_NETWORK_EUR {
  SEPA = 'openpayd_exchange_sepa',
}

export enum API_BANK_NETWORK_GBP {
  FPS = 'uk_fps',
}

export enum API_BANK_NETWORK_AED {
  IPIRTGS = 'aed_ipi',
}

export const API_BANK_NETWORK = {
  ...API_BANK_NETWORK_USD,
  ...API_BANK_NETWORK_EUR,
  ...API_BANK_NETWORK_GBP,
  ...API_BANK_NETWORK_AED,
} as const;

export type BankNetworkType =
  (typeof API_BANK_NETWORK)[keyof typeof API_BANK_NETWORK];

export enum API_BANK_NETWORK_FOR_HISTORY {
  SEN = 'silvergate_sen,silvergate_sen_row',
  FEDWIRE = 'silvergate_fedwire,silvergate_fedwire_row,usd_fedwire',
  ACH = 'us_ach',
  SWIFT = 'silvergate_swift,silvergate_swift_retail,usd_swift',
  CUBIX = 'usd_cubix',
  SEPA = 'openpayd_exchange_sepa',
  FPS = 'uk_fps',
  RTGS = 'aed_rtgs',
  IPI = 'aed_ipi',
}

export const API_BANK_NETWORK_CURRENCY: Record<string, string> = {
  usd_fedwire: 'USD',
  us_ach: 'USD',
  usd_swift: 'USD',
  usd_cubix: 'USD',
  openpayd_exchange_sepa: 'EUR',
  uk_fps: 'GBP',
  aed_ipi: 'AED',
};

export const FIAT_BANK_ACCOUNT_CAP = 5;

export const PAYMENT_NETWORK_MAP: Record<string, string> = {
  // USD ACH - API returns: us_ach, us_ach_pull, us_ach_push
  us_ach: 'us_ach',
  us_ach_pull: 'us_ach_pull',
  us_ach_push: 'us_ach',

  usd_fedwire: 'usd_fedwire',
  usd_swift: 'usd_swift',
  usd_cubix: 'usd_cubix',

  // EUR SEPA
  openpayd_exchange_sepa: 'openpayd_exchange_sepa',

  // GBP FPS
  uk_fps: 'uk_fps',

  // AED
  aed_ipi: 'aed_ipi',
  aed_rtgs: 'aed_rtgs',
} as const;

export enum FIAT_ACTIVATION_STATUS {
  NOT_AVAILABLE = 'Not.Available',
  NOT_ACTIVATED = 'Not.Activated',
  PENDING_KYC = 'Pending.KYC.Verification',
  PENDING_ADDRESS_VERIFICATION = 'Pending.Address.Verification',
  ADDRESS_VERIFICATION_UNSUCCESFUL = 'Address.Verification.Unsuccessful',
  VERIFICATION_UNSUCCESSFUL = 'Verification.Unsuccessful',
  VERIFICATION_SUCCESSFUL = 'Active',
  KYC_COMPLETED = 'KYC.Completed',
  ACTIVATION_PENDING = 'Activation.Pending',
  ACTIVATION_UNSUCCESSFUL = 'Activation.Unsuccessful',
  ACTIVATED = 'Activated',
  TNC_ACCEPTED = 'TNC.Accepted',
}

export const METHOD_NETWORK_MAP = {
  [FUNDS_DIRECTION.DEPOSIT]: {
    [DepositMethodEnum.InstantDeposit]: [PAYMENT_NETWORK_MAP.us_ach_pull],
    [DepositMethodEnum.BankTransfer]: [
      PAYMENT_NETWORK_MAP.us_ach,
      PAYMENT_NETWORK_MAP.usd_fedwire,
      PAYMENT_NETWORK_MAP.usd_swift,
      PAYMENT_NETWORK_MAP.openpayd_exchange_sepa,
      PAYMENT_NETWORK_MAP.uk_fps,
      PAYMENT_NETWORK_MAP.aed_ipi,
    ],
  },
  [FUNDS_DIRECTION.WITHDRAW]: {
    [WithdrawMethodEnum.BankTransfer]: [
      PAYMENT_NETWORK_MAP.us_ach,
      PAYMENT_NETWORK_MAP.openpayd_exchange_sepa,
      PAYMENT_NETWORK_MAP.uk_fps,
      PAYMENT_NETWORK_MAP.aed_ipi,
    ],
    [WithdrawMethodEnum.WireTransfer]: [
      PAYMENT_NETWORK_MAP.usd_fedwire,
      PAYMENT_NETWORK_MAP.usd_swift,
    ],
  },
};

export const DEPOSIT_ONLY_NETWORKS = [
  PAYMENT_NETWORK_MAP.uk_fps,
  PAYMENT_NETWORK_MAP.aed_ipi,
  PAYMENT_NETWORK_MAP.openpayd_exchange_sepa,
] as const;
